'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var multibase = require('multibase');

var sha = require('multihashing-async/src/sha');

var errcode = require('err-code');

var exporter = require('./exporter');

module.exports = function (keysProtobuf, randomBytes, crypto) {
  crypto = crypto || require('./secp256k1')(randomBytes);

  var Secp256k1PublicKey = /*#__PURE__*/function () {
    function Secp256k1PublicKey(key) {
      _classCallCheck(this, Secp256k1PublicKey);

      crypto.validatePublicKey(key);
      this._key = key;
    }

    _createClass(Secp256k1PublicKey, [{
      key: "verify",
      value: function verify(data, sig) {
        return crypto.hashAndVerify(this._key, sig, data);
      }
    }, {
      key: "marshal",
      value: function marshal() {
        return crypto.compressPublicKey(this._key);
      }
    }, {
      key: "bytes",
      get: function get() {
        return keysProtobuf.PublicKey.encode({
          Type: keysProtobuf.KeyType.Secp256k1,
          Data: this.marshal()
        });
      }
    }, {
      key: "equals",
      value: function equals(key) {
        return this.bytes.equals(key.bytes);
      }
    }, {
      key: "hash",
      value: function hash() {
        return sha.multihashing(this.bytes, 'sha2-256');
      }
    }]);

    return Secp256k1PublicKey;
  }();

  var Secp256k1PrivateKey = /*#__PURE__*/function () {
    function Secp256k1PrivateKey(key, publicKey) {
      _classCallCheck(this, Secp256k1PrivateKey);

      this._key = key;
      this._publicKey = publicKey || crypto.computePublicKey(key);
      crypto.validatePrivateKey(this._key);
      crypto.validatePublicKey(this._publicKey);
    }

    _createClass(Secp256k1PrivateKey, [{
      key: "sign",
      value: function sign(message) {
        return crypto.hashAndSign(this._key, message);
      }
    }, {
      key: "public",
      get: function get() {
        return new Secp256k1PublicKey(this._publicKey);
      }
    }, {
      key: "marshal",
      value: function marshal() {
        return this._key;
      }
    }, {
      key: "bytes",
      get: function get() {
        return keysProtobuf.PrivateKey.encode({
          Type: keysProtobuf.KeyType.Secp256k1,
          Data: this.marshal()
        });
      }
    }, {
      key: "equals",
      value: function equals(key) {
        return this.bytes.equals(key.bytes);
      }
    }, {
      key: "hash",
      value: function hash() {
        return sha.multihashing(this.bytes, 'sha2-256');
      }
      /**
       * Gets the ID of the key.
       *
       * The key id is the base58 encoding of the SHA-256 multihash of its public key.
       * The public key is a protobuf encoding containing a type and the DER encoding
       * of the PKCS SubjectPublicKeyInfo.
       *
       * @returns {Promise<string>}
       */

    }, {
      key: "id",
      value: function () {
        var _id = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var hash;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.public.hash();

                case 2:
                  hash = _context.sent;
                  return _context.abrupt("return", multibase.encode('base58btc', hash).toString().slice(1));

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function id() {
          return _id.apply(this, arguments);
        }

        return id;
      }()
      /**
       * Exports the key into a password protected `format`
       *
       * @param {string} password - The password to encrypt the key
       * @param {string} [format=libp2p-key] - The format in which to export as
       * @returns {Promise<string>} The encrypted private key
       */

    }, {
      key: "export",
      value: function () {
        var _export2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(password) {
          var format,
              _args2 = arguments;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  format = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 'libp2p-key';

                  if (!(format === 'libp2p-key')) {
                    _context2.next = 5;
                    break;
                  }

                  return _context2.abrupt("return", exporter.export(this.bytes, password));

                case 5:
                  throw errcode(new Error("export format '".concat(format, "' is not supported")), 'ERR_INVALID_EXPORT_FORMAT');

                case 6:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function _export(_x) {
          return _export2.apply(this, arguments);
        }

        return _export;
      }()
    }]);

    return Secp256k1PrivateKey;
  }();

  function unmarshalSecp256k1PrivateKey(bytes) {
    return new Secp256k1PrivateKey(bytes);
  }

  function unmarshalSecp256k1PublicKey(bytes) {
    return new Secp256k1PublicKey(bytes);
  }

  function generateKeyPair() {
    return _generateKeyPair.apply(this, arguments);
  }

  function _generateKeyPair() {
    _generateKeyPair = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var privateKeyBytes;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return crypto.generateKey();

            case 2:
              privateKeyBytes = _context3.sent;
              return _context3.abrupt("return", new Secp256k1PrivateKey(privateKeyBytes));

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _generateKeyPair.apply(this, arguments);
  }

  return {
    Secp256k1PublicKey: Secp256k1PublicKey,
    Secp256k1PrivateKey: Secp256k1PrivateKey,
    unmarshalSecp256k1PrivateKey: unmarshalSecp256k1PrivateKey,
    unmarshalSecp256k1PublicKey: unmarshalSecp256k1PublicKey,
    generateKeyPair: generateKeyPair
  };
};